import { Admin as AdminComponent } from "@/components/Admin";
import { AdminPanelNavigation } from "@/components/AdminPanelNavigation";
import { AdminRoleProtection } from "@/components/AdminRoleProtection";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Admin = () => {
  const navigate = useNavigate();

  console.log("=== ADMIN PAGE LOADED ===");
  console.log("Current URL:", window.location.href);
  console.log("Admin page rendering");

  const handleBack = () => {
    navigate('/');
  };

  return (
    <AdminRoleProtection>
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-amber-50">
        <div className="container mx-auto py-8">
          <div className="mb-4">
            <Button onClick={handleBack} variant="outline" size="sm">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </div>
          
          <AdminComponent />
          <AdminPanelNavigation />
        </div>
      </div>
    </AdminRoleProtection>
  );
};

export default Admin;